import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { request } from "../api/config"

const initialState = {
    isLoading: false,
    success: false,
    message: null,
    permissions: [],
    isSubmit: false,
    successAction: false
}

export const getClientProductPermissions = createAsyncThunk(
    'permissions/getClientProductPermissions',
    async (values, thunkAPI) => {
        try {
            const res = await request(`client-product-permissions?clientId=${values.clientId}`)
            if(res.code === 200 || res.code === 11 || res.success === true) {
                return res.permissions || res.data || []
            } else {
                return thunkAPI.rejectWithValue(res.message || 'Houve um erro ao retornar as permissões')
            }
        } catch (e) {
            return thunkAPI.rejectWithValue('Houve um erro ao retornar as permissões')
        }
    }
)

export const createClientProductPermission = createAsyncThunk(
    'permissions/createClientProductPermission',
    async (values, thunkAPI) => {
        try {
            const res = await request('client-product-permissions', 'POST', values)
            if(res.code === 200 || res.code === 201) {
                return res.permission || res.data
            } else {
                return thunkAPI.rejectWithValue(res.message || 'Houve um erro ao criar a permissão')
            }
        } catch (e) {
            return thunkAPI.rejectWithValue('Houve um erro ao criar a permissão')
        }
    }
)

export const deleteClientProductPermission = createAsyncThunk(
    'permissions/deleteClientProductPermission',
    async (values, thunkAPI) => {
        try {
            const res = await request('client-product-permissions', 'DELETE', values)
            if(res.code === 200 || res.code === 204) {
                return values
            } else {
                return thunkAPI.rejectWithValue(res.message || 'Houve um erro ao remover a permissão')
            }
        } catch (e) {
            return thunkAPI.rejectWithValue('Houve um erro ao remover a permissão')
        }
    }
)

const permissionsSlice = createSlice({
    name: 'permissions',
    initialState,
    extraReducers(builder) {
        builder
            .addCase(getClientProductPermissions.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getClientProductPermissions.fulfilled, (state, { payload }) => {
                state.isLoading = false
                state.success = true
                state.permissions = payload
            })
            .addCase(getClientProductPermissions.rejected, (state, { payload }) => {
                state.isLoading = false
                state.success = false
                state.message = payload
            })
            .addCase(createClientProductPermission.pending, (state) => {
                state.isSubmit = true
            })
            .addCase(createClientProductPermission.fulfilled, (state, { payload }) => {
                state.isSubmit = false
                state.successAction = true
                state.permissions = [...state.permissions, payload]
            })
            .addCase(createClientProductPermission.rejected, (state, { payload }) => {
                state.isSubmit = false
                state.successAction = false
                state.message = payload
            })
            .addCase(deleteClientProductPermission.pending, (state) => {
                state.isSubmit = true
            })
            .addCase(deleteClientProductPermission.fulfilled, (state, { payload }) => {
                state.isSubmit = false
                state.successAction = true
                // A API retorna produtos diretamente, então filtramos pelo id do produto
                const productIdToRemove = payload.productId
                state.permissions = state.permissions.filter(
                    p => (p.id || p.productId) !== productIdToRemove
                )
            })
            .addCase(deleteClientProductPermission.rejected, (state, { payload }) => {
                state.isSubmit = false
                state.successAction = false
                state.message = payload
            })
    }
})

const { reducer } = permissionsSlice

export default reducer
